/* eslint-disable no-param-reassign */
import routeListService from '../../services/routeList';

// Shared across both vehicle-position actions (they write the same state):
// only the latest-issued request may commit, so a slow stale response can't
// overwrite a newer one.
let vehiclePositionsSeq = 0;

export default {
  namespaced: true,
  state: {
    allTrips: [],
    ringsById: {},
    vehiclePositions: {},
    availableVehicles: [],
    mapControl: {
      showTrafficLayer: false,
      showTrackingHistory: false,
      showPois: false,
      showUnassignedVehicles: false,
      showRoutePaths: false,
      showRestrictions: false,
    },
  },

  mutations: {
    setAllTrips(state, allTrips) {
      state.allTrips = allTrips;
    },
    setRingsById(state, ringsById) {
      state.ringsById = ringsById;
    },
    setVehiclePositions(state, vehiclePositions) {
      state.vehiclePositions = vehiclePositions;
    },
    setAvailableVehicles(state, availableVehicles) {
      state.availableVehicles = availableVehicles;
    },
    setMapControl(state, payload) {
      state.mapControl = { ...state.mapControl, ...payload };
    },
    resetMapControl(state) {
      state.mapControl = {
        showTrafficLayer: false,
        showTrackingHistory: false,
        showPois: false,
        showUnassignedVehicles: false,
        showRoutePaths: false,
        showRestrictions: false,
      };
    },
  },

  actions: {
    async fetchLiveVehiclePosition({ commit }) {
      vehiclePositionsSeq += 1;
      const seq = vehiclePositionsSeq;
      const vehiclePositions = await routeListService.getTrackingVehiclePosition();
      if (seq !== vehiclePositionsSeq) return vehiclePositions;
      commit('setVehiclePositions', vehiclePositions || {});
      return vehiclePositions;
    },
    async fetchAllVehiclePosition({ commit }) {
      vehiclePositionsSeq += 1;
      const seq = vehiclePositionsSeq;
      const vehiclePositions = await routeListService.getTrackingAllVehiclePosition();
      if (seq !== vehiclePositionsSeq) return vehiclePositions;
      commit('setVehiclePositions', vehiclePositions || {});
      return vehiclePositions;
    },
    async fetchVehiclePosition({ dispatch, state }) {
      return state.mapControl.showUnassignedVehicles
        ? dispatch('fetchAllVehiclePosition')
        : dispatch('fetchLiveVehiclePosition');
    },
  },

  getters: {
    ringsById: (state) => (ringHash) => state.ringsById[ringHash],
    vehiclePositions: (state) => state.vehiclePositions,
    vehiclePositionList: (state) => Object.values(state.vehiclePositions || {}),
    availableVehicles: (state) => state.availableVehicles,
    firstOfRings(state) {
      const rings = Object.values(state.ringsById);
      return rings.map((ring) => ring[0]);
    },
    // this should return the last active ring of each route
    // if there is no active ring, it should return the first ring
    // if all rings are completed, it should return the last ring
    activeRingInstances(state) {
      const rings = Object.values(state.ringsById);
      return rings.map((ring) => {
        const activeIndex = ring.findIndex(
          (item) => item.routeMonitoringInfo.actualDepartureTime && !item.routeMonitoringInfo.actualArrivalTime,
        );

        // if not found, return the first or last ring
        if (activeIndex < 0) {
          // all completed return the last one
          const lastCompletedIndex = ring.findLastIndex(
            (item) => item.routeMonitoringInfo.actualArrivalTime && item.routeMonitoringInfo.actualDepartureTime,
          );
          if (lastCompletedIndex > 0) {
            return lastCompletedIndex === ring.length - 1 ? ring[ring.length - 1] : ring[lastCompletedIndex + 1];
          }
          // return the first one
          return ring[0];
        }

        return ring[activeIndex];
      });
    },
    routeMonitoringInfo(state) {
      if (!state.allTrips.length > 0) return [];
      return state.allTrips[0].routeMonitoringInfo
        ? state.allTrips.map((item) => item.routeMonitoringInfo)
        : state.allTrips;
    },
  },
};

/* eslint-enable no-param-reassign */
